import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";

const UserLayout = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.id) return;

      try {
        const res = await fetch(
          `http://localhost:5000/api/users/${user.id}/permissions`
        );

        const data = await res.json();
        setPermissions(data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchPermissions();
  }, [user?.id]);

  if (!user) return null;

  return (
    <div className="flex min-h-screen w-full bg-white">

      {/* SIDEBAR */}
      <Sidebar permissions={permissions} />

      {/* CONTENT */}
      <div className="flex-1 p-6 overflow-x-hidden">
        <Outlet />
      </div>

    </div>
  );
};

export default UserLayout;